import * as React from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Layout, LayoutProps, Sidebar } from 'react-admin';
import Menu from "./Menu";
import MyAppBar from './AppBar';

const themecolors = createTheme({
    palette: {
        primary: {
            main: '#0664A6',
            light: '#5391d8',
            dark: '#003a77'
        },
        secondary: {
            main: '#1e448f'
        }
    }
});

const theme = createTheme( {
    components:{
        MuiTableRow: {
            styleOverrides: {
                head: {
                    "& > th ": {
                        color: 'black',
                        fontWeight: 'bold',
                    }
                }
            }
        }
    }
});

const CustomSidebar = (props: any) => <Sidebar {...props} size={180} />;

export default (props: LayoutProps) => {
    return (
        <ThemeProvider theme={theme}>
            <Layout
                {...props}
                menu={Menu}
                sidebar={CustomSidebar}
                appBar={MyAppBar}
            />
        </ThemeProvider>
    );
};
